<div style="float:left; width: 100%; height: 250px;">
  <jqxGrid #gridTarjetas [theme]="environment.tema" [width]="'98%'" [height]="'100%'" [source]="dataAdapterTarjetas"
      [columnsresize]="true" [filterable]="true" [showfilterrow]="true" [columns]="columnsTarjetas" [sortable]="true"
      [altrows]="true" [showrowlines]="false" [filterrowheight]="30" [rowsheight]="25" [columnsheight]="25"
      [enabletooltips]="true" [showaggregates]="true" [showstatusbar]="true" [statusbarheight]="20"
      [localization]="langGrid">
  </jqxGrid>
</div>
